import * as PIXI from 'pixi.js';
import { TonejsAudio, Fx } from '@/audio/audio';
// import { MenuBuilder } from './ui/menu-builder';
import throttle from 'lodash.throttle';
import { loadChart } from '@/loader/mxl';
import { WIDTH, HEIGHT } from '@/constants';
import { DebugOverlay } from '@/ui/debug-overlay';
import { Gui2D } from '@/ui/gui';
import { activateScene } from '@/scenes';
import { mapNoteDebug, mapKey } from '@/util/font-util';
import game from '@/model/game';
import { Engine2D } from '../components/engine-2d';
import PianoUtil from '@/util/piano-util';
import { GameSceneAbstract } from '@/scenes/game-scene-abstract';
import moment from 'moment';
import { style } from '../constants';

export const JUDGEMENT_LINE_POS_PX = HEIGHT * 0.1;
const CHART_WIDTH = WIDTH * 0.75, CHART_HEIGHT = HEIGHT * 0.8, BORDER=1;

const SPEED = 70; /* one bar in px */

export class GameScene2D extends GameSceneAbstract {
    audio
    BEATS = 4
    BEAT_TYPE = 4
    chart = {}

    constructor(sceneName = "game-2d") {
        super(sceneName); //	this is	the scene name
        this.createBackground();
        this.notesToUpdate = [];
        // this.ui.setProgress(1);
        this.addChild(new DebugOverlay());
    }

    initJudgementLine() {
        const line = new PIXI.Sprite(PIXI.Texture.WHITE);
        line.anchor.set(0.5, 0.5);
        line.tint = 0x00FF00;
        line.position.x = WIDTH / 2;
        line.position.y = CHART_HEIGHT - JUDGEMENT_LINE_POS_PX;
        line.width = CHART_WIDTH;
        line.height = 3;
        const label = new PIXI.Text('00:00');
        label.position.set(
            WIDTH / 2 - label.width/2,
            CHART_HEIGHT - JUDGEMENT_LINE_POS_PX - label.height / 2
        );
        this.judgementLineLabel = label;
        this.addChild(line);
        this.addChild(label)
    }

    createBackground() {
        const background = PIXI.Sprite.from('public/images/background.jpeg');
        background.anchor.set(0.5, 0.5);
        background.scale.set(1.5, 1.5);
        background.position.set(WIDTH / 2, HEIGHT / 2);
        this.addChild(background);
    }

    update(dt) {
        const currentTime = (this.audio.currentTimeOffsetted /*- game.countInTime*/);
        this.engine.update(currentTime, game.bpm);
        this.judgementLineLabel.text = moment(0).seconds(currentTime).format('mm:ss')
        if (this.audio.currentTime >= this.audio.duration && game.isPlaying) {
            game.isPlaying = false;
            this.showResultsScreen();
        }
    }

    async loadMxl(pathToFile) {
        return super.loadMxl(pathToFile)
            .then(async ({
                measures, attributes,
                beats, beatType,
                divisionsPerQuarterNote,
                key, notes, meta, boundaries }) => {
                const totalLengthBeats = Math.round(this.audio.duration / 60 * game.bpm);
                const totalLengthPx = SPEED * totalLengthBeats;
                const pxPerSecond = totalLengthPx / this.audio.duration;
                // todo dialog check boundaries <=game.settings.pianoConfig.boundaries
                const { min, max } = boundaries;
                const whiteKeys = PianoUtil.whiteKeysBetween(min, max);
                this.pianoKeyWidth = Math.trunc((CHART_WIDTH - BORDER*whiteKeys)/ whiteKeys);
                const engine = new Engine2D({
                    boundaries,
                    chartHeight: CHART_HEIGHT,
                    chartWidth: CHART_WIDTH,
                    judgementLinePositionPx: JUDGEMENT_LINE_POS_PX,
                    pxPerSecond,
                    pianoKeyWidth: this.pianoKeyWidth,
                    notes,
                    totalLengthBeats
                });
                this.engine = engine;
                engine.position.set(WIDTH / 2, HEIGHT / 2 - 100);
                this.notesToUpdate = this.engine.noteSprites;
                this.addChild(engine);
                
                this.ui = new Gui2D({
                    boundaries,
                    pianoWidth: CHART_WIDTH,
                    pianoKeyWidth: this.pianoKeyWidth,
                    pianoKeyBorder: 2,
                    pianoHighlightHeight: HEIGHT
                });
                this.initJudgementLine();
                this.addChild(this.ui);
                this.ui.setProgress(1);
                return Promise.resolve();
            }).catch(e => {
                console.error(e);
                activateScene('error', e);
            });
    }

}